// Comment keyword filter (creator side). A creator keeps a list of words at
// users/{uid}/private/commentFilter = { on: boolean, words: string[] }. Comments on THEIR posts/stories
// whose text contains any of those words are refused by lib/d1-rules.ts (server side), so it cannot be
// bypassed by editing the client. The creator themself is never filtered.
export const COMMENT_FILTER_MAX_WORDS = 50
export const COMMENT_FILTER_MAX_WORD_LEN = 30

/** Lower-case, strip accents, collapse whitespace - used for both stored words and comment text. */
export const normalizeFilterText = (v: unknown): string =>
  String(v ?? '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim()

export const cleanFilterWords = (words: unknown): string[] => {
  if (!Array.isArray(words)) return []
  const out: string[] = []
  for (const w of words) {
    const n = normalizeFilterText(w).slice(0, COMMENT_FILTER_MAX_WORD_LEN)
    if (n.length >= 2 && !out.includes(n)) out.push(n)
    if (out.length >= COMMENT_FILTER_MAX_WORDS) break
  }
  return out
}

export const matchesCommentFilter = (text: unknown, words: unknown): boolean => {
  if (!Array.isArray(words) || typeof text !== 'string' || !text) return false
  const t = normalizeFilterText(text)
  return words.some((w) => typeof w === 'string' && w.length > 0 && t.includes(w))
}
